import Divider, { dividerClasses, DividerProps } from '@mui/material/Divider';
import Fab, { fabClasses, FabProps } from '@mui/material/Fab';
import Paper, { paperClasses, PaperProps } from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import Typography, {
  typographyClasses,
  TypographyProps,
} from '@mui/material/Typography';

export const StyledFab = styled(Fab)<FabProps>(({ theme }) => ({
  [`&.${fabClasses.root}`]: {
    bottom: theme.spacing(2),
    position: 'fixed',
    right: theme.spacing(2),
    zIndex: theme.zIndex.drawer,
  },
}));

export const StyledPaper = styled(Paper)<PaperProps>(({ theme }) => ({
  [`&.${paperClasses.root}`]: {
    marginBottom: theme.spacing(2),
    overflow: 'hidden',
  },
}));

export const StyledTypography = styled(Typography)<TypographyProps>(
  ({ theme }) => ({
    [`&.${typographyClasses.root}`]: {
      backgroundColor: theme.palette.grey[200],
      padding: theme.spacing(1, 2),
    },
  }),
);

export const StyledContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(2),
}));

export const StyledDivider = styled(Divider)<DividerProps>(({ theme }) => ({
  [`&.${dividerClasses.root}`]: {
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
}));
